import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ErrorType } from "../models/ErrorType";
import { StorageService } from "../services/Storage";

interface ErrorState {
    value: ErrorType | null;
}

const initialState: ErrorState = {
    value: null
}

export const errorSlice = createSlice({
    name: 'error',
    initialState,
    reducers: {
        sendError: (state, action: PayloadAction<ErrorType>) => {
            state.value = action.payload;
            StorageService.setError(state.value);
        },
        clearError: (state) => {
            state.value = initialState.value;
            StorageService.clearError();
        }
    },
})

export const {sendError, clearError} = errorSlice.actions;

export default errorSlice.reducer;